import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface JobApplication {
  id: string;
  company: string;
  position: string;
  location: string;
  salary: string;
  salaryType: 'hourly' | 'yearly';
  hoursPerWeek?: number;
  status: 'Applied' | 'Interviewing' | 'Hired' | 'Rejected';
  dateApplied: string;
  link: string;
}

interface JobState {
  applications: JobApplication[];
}

const initialState: JobState = {
  applications: [],
};

const jobSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    addApplication: (state, action: PayloadAction<JobApplication>) => {
      state.applications.push(action.payload);
    },
    updateApplication: (state, action: PayloadAction<JobApplication>) => {
      const index = state.applications.findIndex(app => app.id === action.payload.id);
      if (index !== -1) {
        state.applications[index] = action.payload;
      }
    },
    deleteApplication: (state, action: PayloadAction<string>) => {
      state.applications = state.applications.filter(app => app.id !== action.payload);
    },
  },
});

export const { addApplication, updateApplication, deleteApplication } = jobSlice.actions;
export default jobSlice.reducer;